import React, { MouseEvent } from 'react';

import { IRenderCard } from '../interfaces';
import { RenderButton } from './styles';

export const RenderBtn = ({ setExpand, expand, prop, data }: IRenderCard) => {
  const { horizontal, renderButton } = prop;
  if (renderButton) {
    return (
      <>
        {renderButton({
          data: data,
          isCollapsed: expand,
          onClick: (event: MouseEvent<any, any>) => {
            event.stopPropagation();
            setExpand(!expand);
          },
        })}
      </>
    );
  }

  return (
    <RenderButton
      buttonBorderColor={prop.buttonBorderColor || ''}
      buttonBackgroundColor={prop.buttonBackgroundColor || ''}
      horizontal={!!horizontal}
      expanded={expand}
      onClick={e => {
        e.stopPropagation();
        setExpand(!expand);
      }}
    />
  );
};
